<template>
  <div class="container-fluid fill py-0">
    <b-row class="d-flex align-items-center fill border-bottom mb-0" >
      <b-button size="lg" class="pl-3 py-0 mb-2" variant="dark-link" @click="close">
        <b-icon-arrow-left></b-icon-arrow-left>
      </b-button>
      <h5 class="mb-0 pb-2 pl-1 pr-4">{{ customerDetails && customerDetails.fullName ? customerDetails.fullName : 'New Customer' }}</h5>
      <h6 v-if="customerDetails && customerDetails.customerId" class="mb-0 pb-2 mr-2">Customer ID: {{ customerDetails.customerId }}</h6> <h6><copy-to-clipboard v-if="customerDetails && customerDetails.customerId" :value="customerDetails.customerId"></copy-to-clipboard></h6>
    </b-row>

    <b-row class="mt-2 mr-2">
      
      <b-tabs v-model="activeTab" no-nav-style active-nav-item-class="text-dark border-bottom border-secondary" nav-wrapper-class="border-bottom text-secondary" class="ml-3 w-100" pill-class="secondary" content-class="mt-0">
        <b-tab title="Contact Info">
          <customer-contact :customer="customerDetails || customer" @handleChanges="handleChanges" @setCustomer="setCustomer"></customer-contact>
        </b-tab>
        <b-tab title="Orders" :disabled="!customerDetails || !customerDetails.customerId">
          <customer-orders v-if="customerDetails && customerDetails.customerId" :customerId="customerDetails.customerId" :customer="customerDetails"></customer-orders>
        </b-tab>
        <b-tab lazy title="Inventory" :disabled="!customerDetails || !customerDetails.customerId">
          <customer-inventory v-if="customerDetails && customerDetails.customerId" :customerId="customerDetails.customerId" :customer="customerDetails"></customer-inventory>
        </b-tab>
        <b-tab title="Want List" :disabled="!customerDetails || !customerDetails.customerId || !customerDetails.email || customerDetails.email.length === 0">
          <customer-want-list v-if="customerDetails && customerDetails.customerId" :customerId="customerDetails.customerId" :email="customerDetails.email[0]"></customer-want-list>
        </b-tab>
      </b-tabs>
    </b-row>
  </div>
</template>

<script>

import CustomerOrders from "./CustomerOrders";
import CustomerContact from "./CustomerContact";
import CustomerWantList from "./CustomerWantList";
import CustomerInventory from "./CustomerInventory";
import objectMixin from "../../mixins/object";
import CopyToClipboard from "../CopyToClipboard";



export default {
  name: "CustomerDetails",
  mixins: [ objectMixin ],
  components: { CustomerContact, CustomerOrders, CustomerWantList, CopyToClipboard, CustomerInventory },
  props: ["customer"],
  data() {
    return {
      hasChanges: false,
      customerDetails: null,
      activeTab: 0,
    };
  },
  mounted() {
    if (this.customer) {
        this.setCustomer(this.customer);
        this.$nextTick(() => {
            if (this.customerDetails && this.customerDetails.customerId > 0) {
                this.activeTab = 1; // Set to the "Orders" tab
            }
        });
    }
  },
  methods: {
    close() {
      if (this.hasChanges) {
        const confirmClose = window.confirm("You have unsaved Contact Info changes. Are you sure you want to close?");
        if (!confirmClose) {
          return;
        }
      }
      this.$emit("closeCustomer");
    },
    handleChanges(changes) {
      this.hasChanges = changes;
    },
    setCustomer(customer) {
      this.$set(this, "customerDetails", customer);
    }
  },
};
</script>

<style scoped>
.input-group-text {
  width: 8rem;
}

.disabled-tab {
  pointer-events: none;
  opacity: 0.5;
}

</style>
